import type { IAPI } from '../../apiResponse';
import { getRequest } from '../../httpClient';
import type { ICollection } from '../collection-schema';
import { searchCollectionsResponseSchema } from './search-collections-response';

export async function searchCollectionsApi(query: string) {
  return getRequest<IAPI<ICollection[]>>({
    path: '/collections/search',
    options: { params: { query } },
    schema: searchCollectionsResponseSchema,
  });
}
